<mat-action-list>
    <button
        [attr.data-testid]="consumer.name + '_consumer'"
        mat-list-item *ngFor="let consumer of consumers"
        [ngClass]="{ 'selected': consumer === (selectedConsumer$ | async) ||
        consumer.tag === (selectedConsumer$ | async)?.tag || false }"
        (click)="onConsumerSelected(consumer)"
    >
        {{ consumer.name }}
    </button>
</mat-action-list>
